import { Star } from "lucide-react";

export const RATING_KEYS = ["damp_mould", "repair_speed", "energy_efficiency", "communication", "location", "value_for_money"];
export const RATING_LABELS = {
  damp_mould: "Damp / Mould",
  repair_speed: "Repair Speed",
  energy_efficiency: "Energy Efficiency",
  communication: "Communication",
  location: "Location",
  value_for_money: "Value for Money",
};
export const SCORE_LABELS = ["", "Very bad", "Bad", "Okay", "Good", "No problems"];

export const StarInput = ({ value, onChange, testid }) => (
  <div className="flex items-center gap-3" data-testid={testid}>
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" onClick={() => onChange(n)} data-testid={`${testid}-${n}`}
          className="transition-transform hover:scale-110 focus:outline-none">
          <Star className={`w-7 h-7 ${n <= value ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
        </button>
      ))}
    </div>
    <span className={`text-sm font-semibold ${value ? "text-navy" : "text-slate-400"}`} data-testid={`${testid}-label`}>
      {value ? SCORE_LABELS[value] : "Not rated"}
    </span>
  </div>
);

export const Stars = ({ value, size = "w-4 h-4" }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} className={`${size} ${n <= Math.round(value) ? "fill-emerald-500 text-emerald-500" : "text-slate-300"}`} />
    ))}
  </div>
);

export const ScorePill = ({ value }) => (
  <span className="inline-flex items-center gap-2 bg-mint-soft text-navy px-3 py-1 rounded-lg font-mono font-semibold">
    {value ? value.toFixed(1) : "—"}
    <Stars value={value} />
  </span>
);

export const RatingBar = ({ label, value }) => (
  <div className="flex flex-col gap-1.5">
    <div className="flex items-center justify-between">
      <span className="text-xs font-semibold uppercase tracking-wider text-slate-500 font-mono">{label}</span>
      <span className="font-mono font-semibold text-navy">{value ? value.toFixed(1) : "—"}</span>
    </div>
    <div className="h-2.5 bg-slate-100 rounded-full overflow-hidden">
      <div className="h-full bg-mint rounded-full transition-all" style={{ width: `${(value / 5) * 100}%` }} />
    </div>
  </div>
);
